import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-primary text-white relative overflow-hidden" data-id="element-65">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-66">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[120%] bg-white/5 rotate-12 blur-3xl rounded-full" data-id="element-67"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[100%] bg-accent/10 -rotate-12 blur-3xl rounded-full" data-id="element-68"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-70">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 font-serif leading-tight" data-id="element-71">
            Empezá hoy a mejorar la vida de tu perro
          </h2>

          <p className="text-xl md:text-2xl text-white/80 mb-10 max-w-2xl mx-auto font-medium" data-id="element-72">
            No esperes a que su salud empeore. Podés empezar hoy mismo, de forma
            simple y segura.
          </p>

          <div className="flex justify-center" data-id="element-73">
            <CTAButton className="text-xl md:text-2xl py-5 px-10 bg-accent hover:bg-orange-600 text-white shadow-xl shadow-orange-900/20" text="QUIERO EMPEZAR HOY" data-id="element-74" />
          </div>

          <p className="mt-8 text-sm text-white/60 font-medium" data-id="element-75">
            Pago único • Acceso de por vida • Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}